// extracted by mini-css-extract-plugin
export default {"logoBlock":"styles_logoBlock__KrXeg","submitButton":"styles_submitButton__x1TdW"};